const user = (axios) => {
  return {

    /**
         * @method get
         * @api /api/user/
         */
    get () {
      return axios.get('/user', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('user-token')}`,
        },
      })
        .then((response) => response);
    },

    /**
         * @params params
         * @method get
         * @api /api/user/get_all
         */
    getAll (params) {
      return axios.get('/user/get_all', {
        params: params,
      })
        .then((response) => response);
    },

    /**
         * @method get
         * @api /api/user/profile
         */
    getProfile () {
      return axios.get('/user/profile', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('user-token')}`,
        },
      })
        .then((response) => response);
    },

    /**
         * @method post
         * @api /api/user/profile
         */
    updateProfile (params) {
      return axios.post('/user/profile', params)
        .then((response) => response);
    },

    /**
         * Get selected languages
         */

    getSelectedLanguages () {
      return axios.get('/lang/selected')
        .then((response) => response);
    },

    /**
         * @method get
         * @api /api/user/account_types/
         */
    getAccounts () {
      return axios.get('/user/account_types')
        .then((response) => response);
    },

    /**
         * @method get
         * @api /api/user/getTitles/
         */
    getTitle () {
      return axios.get('/user/getTitles')
        .then((response) => response);
    },

    /**
         * @params name
         * @method get
         * @api /api/user/
         */
    search (name) {
      return axios.get(`/sharing_users/${name}`)
        .then((response) => response);
    },

    /**
         * @method get
         * @api /api/user/
         */
    getManagers () {
      return axios.get('/user/managers')
        .then((response) => response);
    },

    /**
         * @method get
         * @api /api/user/lsps
         */
    getLsp () {
      return axios.get('/user/lsps')
        .then((response) => response);
    },

    /**
         * @param params
         * @method post
         * @api /api/user/get_potential_executors
         */
    getExecutors (params) {
      return axios.post(`/user/get_potential_executors/${params.id}`, params.params)
        .then((response) => response);
    },

    /**
         * @param params
         * @method post
         * @api /api/user/csv_import
         */
    uploadCsv (fileForm) {
      return axios.post('/user/csv_import', fileForm, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    },

    /**
         * @method get
         * @api /api/user/get_import_template
         */
    getTemplateCsv () {
      return axios.get('/user/get_import_template')
        .then((response) => response);
    },
  };
};

export default user;
